;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CommentItemController', CommentItemController)

  /* @ngInject */
  function CommentItemController ($scope, $translate, $q, AuditBaseService, MessageService, ToastService, TasksService, ModalService, CONSTANTS, ArtsService) {
    const getAttachmentDetailsDialogController = () => $q.when(import('../../dialogs/attachment-details/attachment-details-dialog.controller'))

    $scope.toolbarButtons = []

    $scope.flags = {
      loading: false,
      readOnly: true
    }

    const api = {
      getAttachmentDetailsDialogController,
      _handleDeleteComment,
      _defineCommentType,
      _addToolbarButtons,
      _onLockedClick,
      _onPinnedClick,
      _toggleIconLock,
      _toggleIconMark
    }
    this.getApi = () => api

    let _itemType
    let _oldModalReference
    let _originalComment

    activate()

    function activate () {
      const isAuditComment = Boolean($scope.comment.auditId)
      const isWorkflowComment = Boolean($scope.comment.taskId)
      const isAssetComment = Boolean($scope.comment.assetId)
      const isArtComment = Boolean($scope.comment.artId)

      if (isAuditComment) {
        _itemType = 'audit'
      } else if (isWorkflowComment) {
        const commentType = $scope.comment.type
        $scope.comment.to = $scope.comment.value
        _itemType = 'task'

        if (commentType === 'ASSET_COMENT') {
          _itemType = 'asset'
        } else if (commentType === 'RATING') {
          _itemType = 'rating'
        }

        api._defineCommentType($scope.comment)
      } else if (isAssetComment) {
        _itemType = 'asset'
        api._defineCommentType($scope.comment)
      } else if (isArtComment) {
        _itemType = 'art'
      }
      api._addToolbarButtons()
    }

    $scope.handleDeleteCommentClick = function (item) {
      MessageService.warning({
        title: $translate.instant('warning'),
        text: $translate.instant('areYouSureDeleteComment'),
        cancelButton: $translate.instant('no'),
        confirmButton: $translate.instant('yes'),
        closeOnConfirm: true,
        press: api._handleDeleteComment.bind(this, item.id, item)
      })
    }

    $scope.handleCancelCommentClick = function () {
      $scope.comment = _originalComment
      $scope.flags.readOnly = true

      if ($scope.onPinnedChanges) {
        $scope.onPinnedChanges({
          event: {
            type: 'cancel',
            data: $scope.comment
          }
        })
      }
    }

    $scope.handleSaveCommentClick = function (comment) {
      if ($scope.onEdit) {
        $scope.flags.loading = true
        const data = {
          id: comment.id,
          isPrivate: comment.isPrivate,
          assetCommentPin: comment.assetCommentPin,
          value: comment.text.valueOf(),
          type: _itemType,
          userIds: comment.userIds
        }
        $scope.onEdit({
          comment: data,
          next: () => {
            $scope.flags.readOnly = true
            $scope.flags.loading = false
          }
        })
      }
    }

    $scope.handleEditCommentClick = function (comment) {
      _originalComment = Object.assign({}, comment)
      $scope.flags.readOnly = false

      comment.text = comment.to

      comment.annotationOptions = {
        lookup: 'name',
        menuItemTemplate: function (item) {
          return (`
            <div class="annotation-user-item">
              ${item.original.profileImageId
              ? `<img src="${CONSTANTS.URL_BACKEND}/users/${item.original.id}/profileImage">`
              : '<i class="user circle icon"></i>'}
              <div>
                <b>${item.original.name}</b>
                <span>${item.original.email}</span>
              </div>
            </div>
          `)
        },
        selectTemplate: function (item) {
          return (`
            <span class="annotation-user-select" title="${item.original.email}">@${item.original.name}</span>
          `)
        },
        values: comment.usersAvailable,
        onSelect: function (user) {
          if (!comment.userIds) {
            comment.userIds = []
          }
          comment.userIds.push(user.id)
        },
        onRemove: function (user) {
          if (!comment.userIds) {
            return
          }
          const index = comment.userIds.indexOf(user.id)
          if (index >= 0) {
            comment.userIds.splice(index, 1)
          }
        }
      }

      api._toggleIconLock()
      api._toggleIconMark()
    }

    $scope.openAttachmentDetails = function (comment) {
      if (comment.asset) {
        _oldModalReference = ModalService.getCurrentModal()

        const asset = {
          id: comment.asset.id,
          name: comment.asset.name,
          extension: comment.asset.extension,
          createdBy: comment.author.id,
          task_has_asset: {
            taskId: comment.taskId,
            isPrivate: comment.isPrivate
          }
        }

        api.getAttachmentDetailsDialogController().then(({ AttachmentDetailsDialogController }) => {
          ModalService.showModal({
            templateId: 'attachmentDetails.html',
            templateUrl: '/core/dialogs/attachment-details/attachment-details-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: AttachmentDetailsDialogController,
            data: {
              attachment: asset
            }
          }).then(() => {
            if (_oldModalReference) {
              ModalService.setCurrentModal(_oldModalReference)
              ModalService.showCurrentModal()
              $scope.$emit('workflow.reloadComments')
            }
          })
        })
      }
    }

    function _handleDeleteComment (commentId, item) {
      if (_itemType === 'asset') {
        TasksService.deleteAssetComment(commentId).then(() => {
          $scope.$emit('deleted-asset-comment', item)
        }).catch(ToastService.defaultErrorToast)
      } else if (_itemType === 'audit') {
        AuditBaseService.deleteAuditComment(commentId, item.auditId).then(() => {
          $scope.$emit('deleted-audit-comment', commentId)
        }).catch(ToastService.defaultErrorToast)
      } else if (_itemType === 'task') {
        TasksService.deleteTaskComment(item.taskId, commentId).then(() => {
          $scope.$emit('deleted-task-comment')
        }).catch(ToastService.defaultErrorToast)
      } else if (_itemType === 'art') {
        ArtsService.deleteComment(item.artId, commentId).then(() => {
          $scope.$emit('deleted-art-comment', commentId)
        }).catch(ToastService.defaultErrorToast)
      }
    }

    function _defineCommentType (comment) {
      if (comment.type === 'BRIEFING_REJECTED') {
        $scope.task = { status: 'REJECTED' }
      } else if (comment.type === 'BRIEFING_NEEDS_MODIFICATION') {
        $scope.task = { status: 'WAITING_ADM_ADJUST' }
      } else if (comment.type === 'REVIEW_REQUIRED') {
        $scope.task = { status: 'REVIEW' }
      } else if (comment.type === 'TASK_TO_DONE') {
        $scope.task = { status: 'DONE' }
      }
    }

    function _addToolbarButtons () {
      if ($scope.showIsPrivate) {
        $scope.toolbarButtons.push(
          {
            className: 'trix-icon-lock-button',
            svgName: 'lock-unlock',
            position: 'right',
            tooltip: 'ocultFromUser',
            onClick: (event) => api._onLockedClick(event)
          }
        )
      }
      if ($scope.showPinnedToolbar) {
        $scope.toolbarButtons.push(
          {
            className: 'trix-icon-pin-button',
            svgName: 'crosshair',
            position: 'right',
            tooltip: 'pinCommentImage',
            onClick: (event) => api._onPinnedClick(event)
          }
        )
      }
    }

    function _onLockedClick (event) {
      $scope.$apply(() => {
        $scope.comment.isPrivate = !$scope.comment.isPrivate
        api._toggleIconLock()
      })
    }

    function _onPinnedClick (event) {
      $scope.$apply(() => {
        let eventType = 'add'
        let eventData

        if ($scope.comment.assetCommentPin) {
          eventData = Object.assign({}, $scope.comment.assetCommentPin)
          eventType = 'remove'
          $scope.comment.assetCommentPin = undefined
        }

        if ($scope.onPinnedChanges) {
          $scope.onPinnedChanges({
            event: {
              type: eventType,
              data: eventData
            }
          })
        }

        api._toggleIconMark()
      })
    }

    function _toggleIconLock () {
      const iconLock = $scope.toolbarButtons.find(item => item.className === 'trix-icon-lock-button')
      if (iconLock) {
        if ($scope.comment.isPrivate) {
          iconLock.addClass('lock')
          iconLock.addTooltip('showToUser')
        } else {
          iconLock.removeClass('lock')
          iconLock.addTooltip('ocultFromUser')
        }
      }
    }

    function _toggleIconMark () {
      const iconMark = $scope.toolbarButtons.find(item => item.className === 'trix-icon-pin-button')
      if (iconMark) {
        if ($scope.comment.assetCommentPin) {
          iconMark.addClass('selected')
        } else {
          iconMark.removeClass('selected')
        }
      }
    }
  }
})()
